<template>
    <div>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                code: this.$route.query.code,
                type: this.$route.params.type
            };
        },
        mounted() {
            if (this.code) {
                this.$auth.oauth2({
                    code: true,
                    provider: this.type,
                    params: {
                        code: this.code,
                    }
                });
            }
        }
    }
</script>